"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreDataDictionaryWatchers = exports.coreDataDictionaryReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const get_1 = require("./get.js");
const export_1 = require("./export/index.js");
const object_names_1 = require("./object-names/index.js");
const search_1 = require("./search/index.js");
const views_1 = require("./views/index.js");
exports.coreDataDictionaryReducers = (0, redux_1.combineReducers)({
    export: export_1.coreDataDictionaryExportReducers,
    get: get_1.getCoreDataDictionarySlice.asyncReducers,
    objectNames: object_names_1.coreDataDictionaryObjectNamesReducers,
    search: search_1.coreDataDictionarySearchReducers,
    views: views_1.coreDataDictionaryViewsReducers
});
exports.coreDataDictionaryWatchers = (0, xuder_1.combineAllWatchers)([
    export_1.coreDataDictionaryExportWatchers,
    get_1.getCoreDataDictionarySlice.asyncWatchers,
    object_names_1.coreDataDictionaryObjectNamesWatchers,
    search_1.coreDataDictionarySearchWatchers,
    views_1.coreDataDictionaryViewsWatchers
]);
//# sourceMappingURL=index.js.map